var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useDropEventContext } from 'root/src/client/web/record/DropEvent/contexts/dropEvent.context';
import { DareContextProvider } from 'root/src/client/web/list/listItemComponents/dare/contexts/dare';
import { DareCard } from 'root/src/client/web/list/listItemComponents/dare/DareCard';
import { getDropEventImage } from 'root/src/shared/drops/helpers/dropEventType.helpers';
import { DarePlatform } from 'root/src/shared/@types/platforms';
export const DropEventDarePlaceholder = () => {
    const dareCardContext = useDropEventDareCardPlaceholder();
    return (<DareContextProvider value={dareCardContext}>
			<DareCard />
		</DareContextProvider>);
};
const useDropEventDareCardPlaceholder = () => {
    const { toggleEmailSubscription, dropEvent, subscribed } = useDropEventContext();
    const onEmailSubscribe = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!subscribed) {
            yield toggleEmailSubscription();
        }
    });
    return {
        subscribed,
        isPlaceholder: true,
        onEmailSubscribe,
        emailSubscription: subscribed,
        comingSoon: true,
        brandProduct: {
            brandProductName: 'Coming soon',
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClick: () => { },
        brand: dropEvent.brand,
        dare: {
            amount: '?',
            games: [
                { image: getDropEventImage(dropEvent) },
            ],
            product: {
                name: 'Coming soon',
                id: 'Coming soon',
                type: 'unknown',
            },
            paymentInfo: {
                brandProductId: 'Coming soon',
                productType: 'unknown',
            },
            capacity: {
                available: '?',
                used: 0,
            },
            title: 'Coming soon',
            description: 'Coming soon',
            platforms: [DarePlatform.Twitch, DarePlatform.YouTube, DarePlatform.TikTok, DarePlatform.YouTubeShorts, DarePlatform.X],
            type: 'creative',
            level: 'easy',
            prizeAvailable: false,
            userCreated: false,
        },
    };
};
